import { useState } from "react";

export interface AccordionProps {
    isAccordionOpen: boolean;
    title: string | React.ReactNode;
    content: React.ReactElement;
    isStyle2?: boolean;
    customStyleClass?: "c-accordion-report-dynamic-grid";
}



const Accordion: React.FunctionComponent<AccordionProps> = (props) => {
    const {
        isAccordionOpen,
        title,
        content,
        isStyle2,
        customStyleClass
    } = props
    const COMPONENT_CLASS = customStyleClass ?? "c-accordion";
    const [isOpen, setIsOpen] = useState(isAccordionOpen);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={`${COMPONENT_CLASS}`}>
            <div className={`${COMPONENT_CLASS}__item${isStyle2 ? "__style-2" : ""} ${isOpen ? "open" : ""}`}>
                <div className="accordion-title" onClick={() => toggle()}>{title}</div>
                <div className="accordion-content">{content}</div>
            </div>
        </div>
    );
};

export default Accordion;